import * as React from "react";
import { throttle } from "lodash-es";

export const useScrollDirection = (isCaseCopied: boolean) => {
  const [scrollDirection, setScrollDirection] = React.useState<
    "up" | "down" | null
  >(null);
  const [headerHidden, setHeaderHidden] = React.useState(false);

  const headerHeightWithoutTabs = isCaseCopied ? 311 : 290;

  React.useEffect(() => {
    const container = document.querySelector(
      "#content-wrapper"
    ) as HTMLDivElement | null;
    if (!container) {
      return;
    }

    let lastScrollTop = 0;

    const onScroll = throttle((event: Event) => {
      const { scrollTop } = event.target as HTMLDivElement;
      const direction = scrollTop > lastScrollTop ? "down" : "up";
      const shouldReset = scrollTop <= headerHeightWithoutTabs;
      const newHeaderHidden = scrollTop >= headerHeightWithoutTabs;
      setHeaderHidden(newHeaderHidden);
      setScrollDirection(shouldReset ? null : direction);
      lastScrollTop = scrollTop;
    }, 250);

    container.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      if (container) {
        container.removeEventListener("scroll", onScroll);
      }
    };
  }, []);

  return { headerHidden, scrollDirection };
};
